import React from "react";
import { useDrop } from "react-dnd";
import styled from "styled-components";

const Placeholder = styled.div`
  width: ${({ itemLevel }) => `calc(100% - ${itemLevel * 24}px)`};
  margin-left: ${({ itemLevel }) => `${itemLevel * 24}px`};
  height: 4px;
  border-radius: 3px;

  background-color: ${({ isOver, isDraggingUser }) => (isOver && !isDraggingUser ? "#42526E" : "transparent")};
`;

function DropPlaceholder({ userId, itemLevel, isDraggingUser }) {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ["user"],
    drop: () => ({ type: "same-level-user", accountId: userId }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return <Placeholder ref={drop} isOver={isOver} itemLevel={itemLevel} isDraggingUser={isDraggingUser} />;
}

export default DropPlaceholder;
